







































































































































































































































































































































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import Button from '@/components/GenericButton.vue';
import { Action, Getter } from 'vuex-class';
import AdminDeviceTypeService from '@/services/admin.devicetype.service';

@Component({
  components: {
    Button,
  },
})
export default class Modbus extends Vue {
  @Prop({ default: {} }) private deviceType!: any;

  @Action private addToastErrorMessage: any;

  private loading: boolean = false;

  private coils: any[] = [];
  private discreteInputs: any[] = [];
  private holdingRegisters: any[] = [];
  private inputRegisters: any[] = [];

  private viewTab = 0;

  private dataTypes: string[] = [
    'int16',
    'uint16',
    'int32',
    'uint32',
    'float32',
  ];

  private async mounted() {
    if (this.deviceType.lan_protocol !== 'Modbus') {
      this.$router.replace(this.$route.path.replace('modbus', ''));
      return;
    }

    if (this.deviceType.id) {
      const registerConfigs = await AdminDeviceTypeService.getModbusRegisterConfigs(this.deviceType.id);
      this.deviceType.modbus_register_configs = registerConfigs;
    }

    this.deviceType.modbus_register_configs.forEach((register: any) => {
      const registerData = {
        ...register,
        register_address: register.register_address > 10 ? String(register.register_address).substring(1).padStart(4, '0') : String(register.register_address).padStart(4, '0'),
      };

      if (register.register_type === 'coil') {
        this.coils.push(registerData);
      } else if (register.register_type === 'discrete-input') {
        this.discreteInputs.push(registerData);
      } else if (register.register_type === 'holding-register') {
        this.holdingRegisters.push(registerData);
      } else if (register.register_type === 'input-register') {
        this.inputRegisters.push(registerData);
      }
    });
  }

  private addRow(registers: any[]) {
    const { name, register_address, payload_type } = registers.length ? registers[registers.length - 1] : { name: '', register_address: '0000', payload_type: 'uint16'};
    const delta = payload_type.endsWith('32') ? 2 : 1;
    const nextAddress = Number(register_address) + delta;
    registers.push({ name: '', register_address: nextAddress.toString().padStart(4, '0'), payload_type });
  }

  private validateRegisters() {
    const validationOrder = [this.inputRegisters, this.holdingRegisters, this.coils, this.discreteInputs];

    for (const [tabIndex, registerType] of validationOrder.entries()) {
      if (registerType.length === 0) {
        continue;
      }

      let field: string = '';
      const invalidIndex = registerType.findIndex((c: any) => {
        if (!c.name) {
          field = 'name';
          return true;
        }

        if (!c.register_address) {
          field = 'address';
          return true;
        }

        return false;
      });

      if (invalidIndex !== -1) {
        this.addToastErrorMessage(`All register configurations must have ${field === 'name' ? 'a name' : 'an address'}.`);
        this.viewTab = tabIndex;
        return false;
      }

      const addressMap: Map<string, string> = new Map(registerType.map((c: any) => [c.register_address, c.name]));
      for (const registerConfig of registerType) {
        const currentlySetRegisterName = addressMap.get(registerConfig.register_address);
        if (currentlySetRegisterName !== registerConfig.name) {
          // if the previous address is also taken by the same register name, it's a 32-bit register
          if (registerConfig.register_address !== '0001' && currentlySetRegisterName === addressMap.get(String(parseInt(registerConfig.register_address, 10) - 1).padStart(4, '0'))) {
            this.addToastErrorMessage(`Register configurations named "${currentlySetRegisterName}" and "${registerConfig.name}" can't share the same addresses - "${currentlySetRegisterName}" is of 32-bit type (takes 2 registers).`);
            this.viewTab = tabIndex;
            return false;
          }

          this.addToastErrorMessage(`Register configurations named "${registerConfig.name}" and "${currentlySetRegisterName}" can't share the same address.`);
          this.viewTab = tabIndex;
          return false;
        }

        // validate 32-bit registers
        if (registerConfig.payload_type && registerConfig.payload_type.includes('32')) {
          const nextRegisterAddress = String(parseInt(registerConfig.register_address, 10) + 1).padStart(4, '0');
          if (addressMap.has(nextRegisterAddress)) {
            this.addToastErrorMessage(`Register configurations named "${addressMap.get(nextRegisterAddress)}" and "${registerConfig.name}" can't share the same addresses - "${registerConfig.name}" is of 32-bit type (takes 2 registers).`);
            this.viewTab = tabIndex;
            return false;
          }

          addressMap.set(nextRegisterAddress, registerConfig.name);
        }
      }
    }

    return true;
  }

  private async save() {
    if (!this.validateRegisters()) {
      return;
    }

    const output = [
      ...this.coils.map((r: any) => ({ ...r, register_address: parseInt(r.register_address, 10), register_type: 'coil' })),
      ...this.discreteInputs.map((r: any) => ({ ...r, register_address: parseInt(`1${r.register_address}`, 10), register_type: 'discrete-input' })),
      ...this.holdingRegisters.map((r: any) => ({ ...r, register_address: parseInt(`4${r.register_address}`, 10), register_type: 'holding-register' })),
      ...this.inputRegisters.map((r: any) => ({ ...r, register_address: parseInt(`3${r.register_address}`, 10), register_type: 'input-register' })),
    ];

    this.deviceType.modbus_register_configs = output;

    if (this.deviceType.id) {
      this.loading = true;
      try {
        await AdminDeviceTypeService.setModbusRegisterConfigs(this.deviceType.id, output);
      } finally {
        this.loading = false;
      }
    }
  }
}
